import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import { ReactNode } from 'react';

import { toCodePoint } from '../emoji/Emoji';

interface EmojiTextProps {
  children: ReactNode;
  className?: string;
  emoji: string;
  unicode?: string;
  emojiAsText?: boolean;
}

const EmojiText: React.FC<EmojiTextProps> = ({ children, className, emoji, unicode, emojiAsText }) => {
  const emojiCodePoint = unicode ? unicode : toCodePoint(emoji);
  const {
    i18n: { language },
  } = useTranslation('common');

  return (
    <div className={clsx('flex items-center', emojiAsText ? 'gap-1' : 'gap-2')}>
      <div className='flex shrink-0 items-center'>
        {emojiAsText ? (
          emoji
        ) : (
          <Image
            alt={emoji}
            className='h-4 w-4 shrink-0'
            height={16}
            src={`https://cdn.jsdelivr.net/npm/emoji-datasource-apple@14.0.0/img/apple/64/${emojiCodePoint}.png`}
            width={16}
          />
        )}
      </div>
      <p lang={language} className={clsx(className, 'hyphens-auto break-words')}>
        {children}
      </p>
    </div>
  );
};

export default EmojiText;
